import { makeStyles, Snackbar } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'
import React from 'react'
import { useStateValue } from 'context/store'

const useStyles = makeStyles(theme => ({
   root: {
      width: '100%',
      '& > * + *': {
         marginTop: theme.spacing(2)
      }
   }
}))

function Alert(props) {
   return <MuiAlert elevation={6} variant="filled" {...props} />
}

function NotificationBar() {
   const classes = useStyles()
   const [{ openSnackbar = {} }, dispatch] = useStateValue()
   const { open, severity, message } = openSnackbar

   function closeSnackbar() {
      dispatch({ type: 'CLOSE_SNACKBAR' })
   }

   return (
      <div className={classes.root}>
         <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={open}
            autoHideDuration={8000}
            onClose={closeSnackbar}
         >
            <Alert severity={severity} onClose={closeSnackbar}>
               {message || 'Lo sentimos, hubo un error, intentelo más tarde.'}
            </Alert>
         </Snackbar>
      </div>
   )
}

export default NotificationBar
